'use client'

/**
 * <GliderBackdrop> — wiederverwendbarer atmosphärischer Hintergrund
 * für alle öffentlichen Seiten mit FAQ-R4-Referenz-Pattern.
 *
 * - LivingThermal (Thermik-Welle) — IMMER sichtbar
 * - award-noise (Korn-Textur)     — IMMER sichtbar
 * - GliderSwarm (animierte Segler) — Toggle-bar (via Header-Pille)
 *
 * R100.51 (2026-05-27): Toggle-Knopf wandert aus dem fixierten Bottom-Right
 * in den Header (siehe <SeglerToggle> in fgl-header). Hier nur noch die
 * Listener-Logik, kein Button mehr.
 *
 * Verwendung:
 *   <div data-award="true" className="min-h-screen relative overflow-x-clip"
 *        style={{ background: 'var(--bg-primary)' }}>
 *     <GliderBackdrop />
 *     <FglHeader />
 *     ...content...
 *   </div>
 */

import { useEffect, useState } from 'react'
import { LivingThermal } from './living-thermal'
import { GliderSwarm } from './glider-swarm'

export const SEGLER_LS_KEY = 'fgl-glider-on'
export const SEGLER_EVENT = 'fgl-segler-toggle'

export function GliderBackdrop() {
  const [on, setOn] = useState(true)

  useEffect(() => {
    try {
      const v = localStorage.getItem(SEGLER_LS_KEY)
      if (v === '0') setOn(false)
    } catch { /* localStorage blockiert */ }
    function handler(e: Event) {
      const detail = (e as CustomEvent<{ on: boolean }>).detail
      if (detail && typeof detail.on === 'boolean') setOn(detail.on)
    }
    window.addEventListener(SEGLER_EVENT, handler as EventListener)
    return () => window.removeEventListener(SEGLER_EVENT, handler as EventListener)
  }, [])

  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      style={{ zIndex: -1, height: '100%' }}
      aria-hidden="true"
    >
      <LivingThermal />
      <div className="absolute inset-0 award-noise pointer-events-none" />
      {on && <GliderSwarm soundEnabled={false} audioContext={null} />}
    </div>
  )
}
